import mitt from 'mitt';
import type { SnackbarOptions } from '@/components/base/OareSnackbar.vue';

export const ACTIONS = {
  TOAST: 'toast',
  CLOSE_TOAST: 'close',
  COMMENT_DIALOG: 'comment-dialog',
  EDIT_WORD_DIALOG: 'edit-word-dialog',
  SPECIAL_CHAR_INPUT: 'special-char-input',
} as const;

// Vue 3 removed $on/$off/$emit from component instances, so the bus is a
// plain emitter. Payload types are loose on purpose: the dialog events carry
// ad hoc objects that only their two listeners know the shape of.
type Events = {
  [ACTIONS.TOAST]: SnackbarOptions;
  [ACTIONS.CLOSE_TOAST]: void;
  [ACTIONS.COMMENT_DIALOG]: any;
  [ACTIONS.EDIT_WORD_DIALOG]: any;
  [ACTIONS.SPECIAL_CHAR_INPUT]: string;
};

const EventBus = mitt<Events>();

export default EventBus;
